import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function TablePageSelect({ newpage, data, page }) {
    const maxPagesRaw = Number(data?.page?.max_pages);
    const maxPages = Number.isFinite(maxPagesRaw) && maxPagesRaw > 0 ? maxPagesRaw : 1;
    const recordsNumber = data?.page?.records_number ?? 0;
    const currentPage = Math.min(
        Math.max(1, parseInt(page, 10) || 1),
        maxPages,
    );

    const handleChange = async (event, pageNumber) => {
        await newpage(pageNumber);
    };

    return (
        <Stack
            direction={{ xs: 'column', sm: 'row' }}
            alignItems={{ xs: 'flex-start', sm: 'center' }}
            justifyContent="space-between"
            spacing={1.5}
            sx={{
                mt: 2,
                pt: 2,
                borderTop: '1px solid #eee',
            }}
        >
            <Typography variant="body2" color="text.secondary">
                {recordsNumber} record{recordsNumber === 1 ? '' : 's'}
            </Typography>

            <Box sx={{ alignSelf: { xs: 'stretch', sm: 'auto' } }}>
                <Pagination
                    page={currentPage}
                    count={maxPages}
                    onChange={handleChange}
                    color="primary"
                    shape="rounded"
                    size="small"
                    siblingCount={1}
                    boundaryCount={1}
                    sx={{
                        '& .MuiPaginationItem-root': {
                            borderRadius: '8px',
                            fontWeight: 500,
                        },
                    }}
                />
            </Box>
        </Stack>
    );
}

export default TablePageSelect;
